import script from "./RfidItem.vue?vue&type=script&setup=true&lang=js"
export * from "./RfidItem.vue?vue&type=script&setup=true&lang=js"

import "./RfidItem.vue?vue&type=style&index=0&id=042f9bf2&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-042f9bf2"]])

export default __exports__